<template>
  <div class="account-created text-center">
    <iconCheck class="icon-check mt-5"/>

    <h1 class="title mb-2 mt-3">
      {{ $t('onboardingSuccess.title') }}
    </h1>

    <div class="desc mb-4">{{ $t('onboardingSuccess.description') }}</div>

    <v-container>
      <ytplayer v-if="!videoEnded" class="mb-8" videoId='6dReE2kdJXc' @ended="videoEnded = true"></ytplayer>
      <div v-else class="arrow bounce-arrow"><iconDownArrow /></div>
    </v-container>

    <div class="ml-wrapper">
      <div class="magic-link-title ma-auto pt-8 mb-6">{{ $t('onboardingSuccess.magicLinkTitle') }}</div>
      <magic-link></magic-link>
    </div>
  </div>
</template>

<script>
import MagicLink from '../settings/magicLink.vue';
import iconCheck from '@/static/custom-img/iconCheck.svg';
import iconDownArrow from '@/static/custom-img/down-arrow.svg';
import ytplayer from '@/components/base/ytplayer';

export default {
  components: {
    iconCheck,
    iconDownArrow,
    MagicLink,
    ytplayer,
  },

  data () {
    return {
      videoEnded: false,
    };
  },

  computed: {
    user () {
      return this.$store.state.user.data.data;
    },

    isSubscribed () {
      return this.user.isSubscribed && this.user.subscription;
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-check {
  width: 56px;
  height: 56px;
}

.ml-wrapper {
  background: white;
}

.title {
  color: #44445E;
  font-weight: bold;
  text-align: center;
  letter-spacing: -0.175px;
  font-size: 32px !important;
  line-height: 39px !important;
  max-width: 600px;
  margin: auto;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    font-size: 28px !important;
    line-height: 34px !important;
  }
}

.desc {
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #707070;
}

.magic-link-title {
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #44445E;
  max-width: 370px;

  @media #{map-get($display-breakpoints, 'xs-only')} {
    font-size: 18px;
    line-height: 22px;
  }
}

.arrow {
  svg {
    width: 280px;
    height: 210px;
  }
}
</style>
